import hljs from 'highlight.js/lib/core'
import javascript from 'highlight.js/lib/languages/javascript'
import json from 'highlight.js/lib/languages/json'
import sql from 'highlight.js/lib/languages/sql'
import typescript from 'highlight.js/lib/languages/typescript'
import yaml from 'highlight.js/lib/languages/yaml'
import { ClientOnly } from 'remix-utils/client-only'

// Then register the languages you need
hljs.registerLanguage('json', json)
hljs.registerLanguage('sql', sql)
hljs.registerLanguage('yaml', yaml)
hljs.registerLanguage('javascript', javascript)
hljs.registerLanguage('typescript', typescript)

enum CodeBlockLanguage {
  JAVASCRIPT = 'javascript',
  JSON = 'json',
  SQL = 'sql',
  TYPESCRIPT = 'typescript',
  YAML = 'yaml',
}

type Props = {
  language: CodeBlockLanguage
  children: string
}

export const CodeBlock = ({ children, language }: Props) => (
  <ClientOnly>
    {() => (
      <pre>
        <code
          className={`hljs token language-${language}`}
          dangerouslySetInnerHTML={{
            __html: hljs.highlight(String(children), {
              language,
              ignoreIllegals: true,
            }).value,
          }}
        />
      </pre>
    )}
  </ClientOnly>
)
